import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

const CompletionBar = () => {
  return (
    <Card className="card-height-100">
      <CardHeader className="border-bottom-0 pb-0">
        <h4 className="card-title mb-0">Completion</h4>
      </CardHeader>
      <CardBody>
        <div className="text-left">
          <h3 className="display-6 fw-bold mb-0">95%</h3>
          <p className="text-muted mb-1">Controls OK</p>
          <p className="text-muted fw-medium">104 controls</p>
        </div>

        <div className="mt-4">
          <p className="mb-1">
            To Do <span className="float-end">104 total</span>
          </p>
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar bg-warning"
              role="progressbar"
              style={{ width: "99%" }}
              aria-valuenow="99"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>

          <p className="mt-3 mb-3">
            In Progress <span className="float-end">37/38</span>
          </p>
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar bg-warning"
              role="progressbar"
              style={{ width: "97%" }}
              aria-valuenow="97"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>

            
          </div>

           <p className="mt-3 mb-3">
            Completed <span className="float-end">1/38</span>
          </p>
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar bg-warning"
              role="progressbar"
              style={{ width: "99%" }}
              aria-valuenow="99"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default CompletionBar;
